import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { DealerReviewInterface } from 'types/Apis/SearchURL';

import ReviewerInfo from '../Reviews/ReviewerInfo';
import LabeledStarRatings from '../Reviews/LabeledStarRatings';
import { ReviewTitleContent, ReviewBodyContent } from '../Reviews/ReviewTextContent';

interface DealerReviewProps {
  review: DealerReviewInterface;
}

export default function DealerReview({ review }: DealerReviewProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="dealer-review">
      <ReviewerInfo
        reviewerName={review.reviewerName}
        bestLocationDisplayName={review.bestLocationDisplayName}
        className="dealer-reviewer-info"
      />

      <ReviewTitleContent>{review.dealerName}</ReviewTitleContent>
      <div className="make-model">{`${review.modelYear} ${review.makeName} ${review.modelId}`}</div>
      <ReviewBodyContent>{review.review}</ReviewBodyContent>
      <div className="ratings">
        <LabeledStarRatings
          ratings={{
            [t('seoSrp.dealerReviews.overall')]: review.overallRating,
            [t('seoSrp.dealerReviews.facility')]: review.facilityRating,
            [t('seoSrp.dealerReviews.process')]: review.processRating,
            [t('seoSrp.dealerReviews.service')]: review.serviceRating,
          }}
          color="gold"
        />
      </div>

      <style jsx>{`
        .dealer-review {
          box-shadow: 0px 1px 0px #d3d3d3;
          margin-bottom: 29px;
        }

        .make-model {
          font-weight: 600;
          font-size: 18px;
          line-height: 24px;
          letter-spacing: 0.2px;
          color: ${colors.G3};
          padding-bottom: 16px;
        }

        .ratings {
          width: 200px;
          padding-bottom: 32px;
          padding-top: 12px;
        }
      `}</style>

      <style jsx global>{`
        .reviewer.dealer-reviewer-info {
          padding-bottom: 26px;
        }
      `}</style>
    </div>
  );
}
